import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import axios from 'axios';
import moment from 'moment';
import ProductionDataTable from './ProductionDataTable';
import {Message} from 'primereact/message';

export default function CurrentShiftProductionTable({machineIds = null, renderStatus, scope = 'current-shift'}) {
  const {t} = useTranslation('common');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const key = machineIds === null ? 'all' : [...new Set(machineIds)].sort((a, b) => a - b).join(',');
  const network = localStorage.getItem('networkId');
  useEffect(() => {
    let cancelled = false;
    let timer;
    const controller = new AbortController();
    setData(null);
    setLoading(true);
    const load = async () => {
      try {
        const response = await axios.post(`${process.env.REACT_APP_API_HOST}/api/v2/production-job/machine-status/${scope}`, {
          ids: key && key !== 'all' ? key.split(',').map(Number) : [],
          all_machines: key === 'all',
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        }, {signal: controller.signal, headers: {
          Authorization: `Bearer ${localStorage.getItem('userToken')}`,
          'App-Network': network,
        }});
        if (!cancelled) {
          setData(response.data.data);
          setFailed(false);
        }
      } catch (error) {
        if (!cancelled) setFailed(true);
      } finally {
        if (!cancelled) {
          setLoading(false);
          timer = setTimeout(load, 10000);
        }
      }
    };
    load();
    return () => { cancelled = true; controller.abort(); clearTimeout(timer); };
  }, [key, network, scope]);
  return <section className="card p-mb-3">
    <h3>{t(scope === 'open-projects' ? 'openProjectsProductionTitle' : 'shiftProductionTitle')}</h3>
    {data?.shift && <p>{t(`shiftName.${data.shift.name}`, {defaultValue: data.shift.name})} • {moment(data.shift.from).format('YYYY.MM.DD. HH:mm')} – {moment(data.shift.until).format('YYYY.MM.DD. HH:mm')}</p>}
    {failed && <div className="p-mb-2"><Message severity="warn" text={t('shiftRefreshFailed')}/></div>}
    <ProductionDataTable items={data?.items || []} loading={loading} renderStatus={renderStatus}
      emptyMessage={t(scope === 'open-projects' ? 'openProjectsNoTasks' : 'shiftNoTasks')}/>
  </section>;
}
